import { useCallback } from 'react'
import type { MouseEvent } from 'react'
import { isEmpty } from '~/lib/empty'
import { prefectureDisplayName } from '~/lib/prefecture/prefecture'
import { css, cva } from '~/styled-system/css'
import { useAreaMain } from './area'

const tab = cva({
  base: { px: '1', pb: '1' },
  variants: {
    state: {
      active: {
        color: 'gray.800',
        borderBottom: 'tab.active',
      },
      inactive: {
        color: 'tertiary',
        borderBottom: 'none',
      },
    },
  },
})

export function PrefectureTab({
  useSet,
  useSelected,
}: { useSet: () => (v: string) => void; useSelected: () => string | undefined }) {
  const selected = useSelected()
  const set = useSet()
  const onClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      const code = e.currentTarget.dataset.areaCode as string
      set(code)
    },
    [set]
  )
  const areas = useAreaMain()
  if (isEmpty(areas)) {
    return null
  }
  return (
    <nav
      className={css({
        display: 'flex',
        gap: '2',
        alignItems: 'start',
        justifyContent: 'space-between',
        fontSize: 'md',
      })}
    >
      {areas.map((area) => {
        const state = selected === area.code ? 'active' : 'inactive'
        return (
          <button
            type="button"
            className={tab({ state })}
            key={area.code}
            data-area-code={area.code}
            onClick={onClick}
          >
            {prefectureDisplayName(area.label)}
          </button>
        )
      })}
    </nav>
  )
}
